import {
    marketingPriceIndex,
    pricingCurrentPercentIndex,
    pricingCurrentValueIndex,
    pricingProformaPercentIndex,
    pricingProformaValueIndex,
} from "../../utils";

export const buildIncomeAndExpenses = function (isProforma) {
    const table = isProforma ? 'proforma-income-and-expenses' : 'income-and-expenses';
    const pricingPercentIndex = isProforma ? pricingProformaPercentIndex : pricingCurrentPercentIndex;
    const pricingValueIndex = isProforma ? pricingProformaValueIndex : pricingCurrentValueIndex;

    return {
        name: isProforma ? 'Proforma Income & Expenses' : 'Income & Expenses',
        headerRow: [isProforma ? 'Income & Expenses (Proforma)' : 'PROJECTED INCOME & EXPENSES', null, 'CURRENT', 'PSF'],
        footerRow: {
            valueCells: [
                {
                    editable: false,
                    styleClasses: 'font-gotham-bold font-size-10',
                    getComputedValue() {
                        return {displayValue: 'NET OPERATING INCOME'};
                    }
                },
                {empty: true},
                {
                    editable: false,
                    styleClasses: 'font-gotham-bold font-size-10',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const totalExpenses = tabs['pricing-tab'].tables['expenses'].footerRow.valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat(precomputedValues[isProforma ? 'effectiveGrossRevenueProForma':'effectiveGrossRevenue'] + (-totalExpenses));
                        const displayValue = !value || isNaN(value) ? '-' : value < 0 ?`($${(value.toLocaleString().replace("-",""))})`:`$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
                {
                    editable: false,
                    styleClasses: 'font-gotham-bold font-size-10',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const noi = isProforma ? precomputedValues.netOperatingIncomeProForma : precomputedValues.netOperatingIncome;
                        const value = parseFloat( noi / precomputedValues.totalSpace);
                        const displayValue = !value  || isNaN(value) || !isFinite(value) ? '-' : value < 0 ? `($${(value.toLocaleString(undefined, {minimumFractionDigits: 2 , maximumFractionDigits: 2}).replace("-",""))})`:`$${value.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                },
            ]
        },
        rows: {
            'base-rent-occupied-space': {
                valueCells: [
                    {
                        editable: false,
                        hasExpandButton: true,
                        getComputedValue() {
                            return {displayValue: 'Base Rent - Occupied Space'};
                        }
                    },
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[pricingPercentIndex].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Total
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            //const totalSpace = precomputedValues.totalSpace;
                            const _value = tabs['current-rr-tab'].tables['sumed-general-information'].rows['first-row'].valueCells[marketingPriceIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(total / _value);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'base-rent-lease-up-space': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Base Rent - Lease Up Space'};
                        }
                    },
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[1].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const isProformaPricing = tabs['pricing-tab'].tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value;
                            const index = isProformaPricing ? pricingProformaValueIndex : pricingCurrentValueIndex;
                            const value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['vacant-space'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            if (isProforma) {
                                return { internalValue: value, displayValue: displayValue };
                            }
                            // return empty values if type is not proforma same as per pricing tab
                            return { internalValue: 0, displayValue: '$0' };
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            //const totalSpace = precomputedValues.totalSpace;
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['second-row'].valueCells[marketingPriceIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'base-rent-additional-price': {
                valueCells: [
                    {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs) {
                            const displayValue = tabs['pricing-tab'].tables['base-rent'].rows['additional-price'].valueCells[0].value || '';
                            return {displayValue: `Base Rent - ${displayValue}`};
                        }
                    },
                    {
                        empty: true,
                        hidden: true,
                    },
                    {
                        editable: false,
                        hidden: true,
                        name:'base-rent-additional-price',
                        getComputedValue(tabs) {
                            const value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['additional-price'].valueCells[pricingValueIndex].value);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF
                        editable: false,
                        hidden: true,
                        name:'base-rent-additional-price',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = isProforma || !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'gross-potential-rent': {
                valueCells: [
                    {
                        editable: false,
                        styleClasses: 'font-gotham-bold font-size-10',
                        getComputedValue() {
                            return {displayValue: 'GROSS POTENTIAL RENT'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const occupiedTotal = tabs['marketing-tab'].tables[table].rows['base-rent-occupied-space'].valueCells[marketingPriceIndex].getComputedValue(tabs, 'base-rent-occupied-space', precomputedValues).internalValue;
                            const leaseUpTotal = tabs['marketing-tab'].tables[table].rows['base-rent-lease-up-space'].valueCells[marketingPriceIndex].getComputedValue(tabs, 'base-rent-lease-up-space', precomputedValues).internalValue;
                            const additionalPrice = isProforma ? 0 : parseInt(tabs['pricing-tab'].tables['base-rent'].rows['additional-price'].valueCells[2].value) || 0;
                            const value = occupiedTotal + leaseUpTotal + additionalPrice;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const pfGrossRentalRevenue = tabs['pricing-tab'].tables['base-rent'].footerRow.valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(pfGrossRentalRevenue / precomputedValues.totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                            return { internalValue: value, displayValue: displayValue }
                        }

                        
                    },
                ]
            },
            'exp-reimb': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ' Expense Reimbursements'}
                        }
                    },
                    {empty: true},
                    {empty: true},
                    {empty: true},

                ]
            },
            'real-estate-taxes': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Real Estate Taxes'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].rows['real-estate-taxes'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                ]
            },
            'insurance': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Insurance'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].rows['insurance'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                ]
            },
            'cam': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'CAM'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].rows['cam'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                ]
            },
            'mgmt-fee': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Management Fee'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].rows['mgmt-fee'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                ]
            },
            'annual-other-income': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue(tabs) {
                            const displayValue = tabs['pricing-tab'].tables['exp-reimb'].rows['annual-other-income'].valueCells[0].value || '-';
                            return {displayValue: displayValue}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].rows['annual-other-income'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                ]
            },
            'total-exp-reimb': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Total Expense Reimbursements'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = Math.round(tabs['pricing-tab'].tables['exp-reimb'].footerRow.valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                ]
            },
            'gross-potential-income': {
                valueCells: [
                    {
                        editable: false,
                        styleClasses: 'font-gotham-bold font-size-10',
                        getComputedValue() {
                            return {displayValue: 'GROSS POTENTIAL INCOME'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const grossPotentialRent = tabs['marketing-tab'].tables[table].rows['gross-potential-rent'].valueCells[marketingPriceIndex].getComputedValue(tabs, 'gross-potential-rent', precomputedValues).internalValue;
                            const totalExpReimb = tabs['marketing-tab'].tables[table].rows['total-exp-reimb'].valueCells[marketingPriceIndex].getComputedValue(tabs, 'total-exp-reimb', precomputedValues).internalValue;
                            const value = grossPotentialRent + totalExpReimb;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },
                ]
            },
            'vacancy-factor': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Vacancy Factor'}
                        }
                    },
                    {
                        editable: false,
                        getComputedValue(tabs) {
                            const value = parseFloat(tabs['pricing-tab'].tables['total-gross-revenue'].rows['vacancy-factor'].valueCells[pricingPercentIndex].value);
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = parseFloat(tabs['pricing-tab'].tables['total-gross-revenue'].rows['vacancy-factor'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(-value).toLocaleString(undefined, {maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : value < 0 ? `($${(-value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})` : `($${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'effective-gross-income': {
                valueCells: [
                    {
                        editable: false,
                        styleClasses: 'font-gotham-bold font-size-10',
                        getComputedValue() {
                            return {displayValue: 'EFFECTIVE GROSS INCOME'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const grossPotentialIncome = tabs['marketing-tab'].tables[table].rows['gross-potential-income'].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const vacancy = tabs['marketing-tab'].tables[table].rows['vacancy-factor'].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = grossPotentialIncome + vacancy;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'expenses': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Operating Expenses'}
                        }
                    },
                    {empty: true},
                    {empty: true},
                    {empty: true},
                ]
            },
            'expenses-real-estate-taxes': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Real Estate Taxes'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = tabs['pricing-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : value < 0 ? `($${(-value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})` : `($${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'expenses-insurance': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Insurance'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = tabs['pricing-tab'].tables['expenses'].rows['insurance'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : value < 0 ? `($${(-value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})` : `($${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'expenses-cam': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'CAM'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = tabs['pricing-tab'].tables['expenses'].rows['cam'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : value < 0 ? `($${(-value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})` : `($${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'expenses-mgmt-fee': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Management Fee'}
                        }
                    },
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = parseFloat(tabs['pricing-tab'].tables['expenses'].rows['mgmt-fee'].valueCells[pricingPercentIndex].getComputedValue(tabs, precomputedValues).internalValue);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = tabs['pricing-tab'].tables['expenses'].rows['mgmt-fee'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : value < 0 ? `($${(-value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})` : `($${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'non-reimbursable-expenses': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Non-Reimbursable Expenses'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const value = tabs['pricing-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[pricingValueIndex].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(-value).toLocaleString()})` : `($${value.toLocaleString()})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : value < 0 ? `($${(-value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})` : `($${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'total-expenses': {
                valueCells: [
                    {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'TOTAL EXPENSES'}
                        }
                    },
                    {empty: true},
                    {
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const realEstateTaxes = Math.abs(tabs['marketing-tab'].tables[table].rows['expenses-real-estate-taxes'].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                            const insurance = Math.abs(tabs['marketing-tab'].tables[table].rows['expenses-insurance'].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                            const cam = Math.abs(tabs['marketing-tab'].tables[table].rows['expenses-cam'].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                            const mgmtFee = Math.abs(tabs['marketing-tab'].tables[table].rows['expenses-mgmt-fee'].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                            const nonReimbursableExpenses = Math.abs(tabs['marketing-tab'].tables[table].rows['non-reimbursable-expenses'].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue);
                            const value = realEstateTaxes + insurance + cam + mgmtFee + nonReimbursableExpenses;
                            const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(-value).toLocaleString(undefined, {maximumFractionDigits: 2})})` : `($${value.toLocaleString(undefined, {maximumFractionDigits: 2})})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const total = tabs['marketing-tab'].tables[table].rows[rowIdentifier].valueCells[marketingPriceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const totalSpace = precomputedValues.totalSpace;
                            const value = parseFloat(total / totalSpace);
                            const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : value < 0 ? `($${(-value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})` : `($${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })})`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'empty-row': {
                valueCells: [{empty: true}, {empty: true}, {empty: true}, {empty: true},]
            }
        },
    };
};